import { useState, useEffect } from 'react';
import axios from 'axios';

const useEthereumPrice = () => {
	const [priceData, setPriceData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchEthereumPrice = async () => {
			try {
				const response = await axios.get('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD');
				setPriceData(response.data);
				setLoading(false);
			} catch (e) {
				setError('Failed to fetch Ethereum price');
				setLoading(false);
				console.error('get eth price error:', e);
			}
		};

		fetchEthereumPrice();
	}, []);

	return { priceData, loading, error };
};

export default useEthereumPrice;
